import React from "react";
import "./Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";

function Banner() {
  return (
    <section className="home_banner">
      <div className="container-fluid  p-0">
        <Swiper
          pagination={true}
          modules={[Pagination, Autoplay]}
          className="mySwiper home_banner_swiper"
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            loop:true
          }}
        >
          <SwiperSlide>
            <div className="img_holder">
              <img
                src="/assets/images/home/banner/banner_1.webp"
                alt="banner 1"
                className="banner_img"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                src="/assets/images/home/banner/banner_2.webp"
                alt="banner 1"
                className="banner_img"
              />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="img_holder">
              <img
                src="/assets/images/home/banner/banner_3.webp"
                alt="banner 1"
                className="banner_img"
              />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
}

export default Banner;
